import { useCallback } from 'react';

import { useEffectOnce } from 'src/lib/hooks';
import { usePopups } from 'src/lib/popups';

import { BrandVoicePopup } from './BrandVoicePopup';

export const BRAND_VOICE_POPUP = Symbol('BRAND_VOICE');

export const useBrandVoicePopup = () => {
  const popups = usePopups();

  useEffectOnce(() => {
    popups.registerPopup(BRAND_VOICE_POPUP, BrandVoicePopup);
  });

  return useCallback(
    ({ brandVoice = null, noRedirect = false, language = null, lockLanguage = false } = {}) => {
      return new Promise((resolve) => {
        popups.openPopup(BRAND_VOICE_POPUP, {
          onClose: (createdBrandVoice) => {
            popups.closePopup(BRAND_VOICE_POPUP);
            if (createdBrandVoice?.id) {
              resolve(createdBrandVoice);
            } else {
              resolve(null);
            }
          },
          brandVoice,
          noRedirect,
          language,
          lockLanguage,
        });
      });
    },
    [popups]
  );
};
